import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import { useInitPushAllowed } from './utils/useInitPushAllowed';
import { useResetEstimExists } from './utils/useResetEstimExists';
import { MobileViewC } from '../../components/App';
import { DesktopViewContainer } from '../DesktopViewContainer';

export const Page: React.VFC = () => {
  useResetEstimExists();
  useInitPushAllowed();

  return (
    <React.Fragment>
      <Responsive desktop>
        <DesktopViewContainer />
      </Responsive>
      <Responsive tablet phone>
        <MobileViewC />
      </Responsive>
    </React.Fragment>
  );
};
